import React, { useEffect } from 'react';
import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_USERPROFILE_DATA } from './graphQL/queries';
import { useDispatch } from 'react-redux';
import * as Actions from './store/actions';
import Loader from './components/tripOverview/Common/Loader';
import { QueryUserProfileResult } from './atom/Types';
import ShareRouterConfig from './shareRouterConfig';
import OverviewRouteConfig from './overviewRouteConfig';
import { USER_PROFILE } from './graphQL/mutations';

const RouterConfig = lazy(() => import('./routerConfig'));

const RoutesPage = () => {
    const { loginWithRedirect, logout, isAuthenticated, user } = useAuth0();
    const dispatch = useDispatch();
    const [getUserProfile, { refetch: UserProfileRefetch }] = useLazyQuery<QueryUserProfileResult>(GET_USERPROFILE_DATA);
    const [AddUserProfile] = useMutation(USER_PROFILE);

    const handleLogin = () => {
        if (window.location.pathname === '/viewer/login') {
            return loginWithRedirect({
                appState: {
                    returnTo: '/viewer/'
                }
            });
        } else if (window.location.pathname === '/viewer/signup') {
            return loginWithRedirect({
                screen_hint: 'signup',
                appState: {
                    returnTo: '/viewer/'
                }
            });
        } else if (window.location.pathname === '/viewer/signout') {
            return logout({ returnTo: window.location.origin + '/viewer/' });
        }
    };

    useEffect(() => {
        handleLogin();

        if (isAuthenticated) {
            getUserProfile({ variables: { email: user?.email }}).then((b) => {
                if (b.data && b.data.queryUserProfile?.length > 0) {
                    dispatch(Actions.Profile(b.data.queryUserProfile[0]))
                }
                else {
                    // auto create user profile if not exist
                    AddUserProfile({
                        variables: {
                            firstName: user?.given_name,
                            lastName: user?.family_name,
                            phone: null,
                            email: user?.email,
                            wishList: [],
                            isFirstLogin: true
                        }
                    }).then((res) => {
                        if (res.data && res.data.addUserProfile) {
                            UserProfileRefetch({
                                variables: { email: user?.email },
                                fetchPolicy: 'network-only' // to ensure we get the latest data
                            }).then((res) => {
                                if (res.data && res.data.queryUserProfile?.length > 0) {
                                    dispatch(Actions.Profile(res.data.queryUserProfile[0]))
                                }
                            }).catch(() => {
                                console.log("Error re-fetching user profile after creation");
                            });
                        }
                    }).catch(() => {
                        console.log("Error creating user profile");
                    });
                }
            }).catch(() => {
                console.log("Error fetching user profile");
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated]);
    return (
        <>
            <Routes>
                <Route
                    path="/viewer/login"
                    element={<Loader content='Redirecting to Log in...' />}
                />
                <Route
                    path="/viewer/signup"
                    element={<Loader content='Redirecting to sign up...' />}
                />
                <Route
                    path="/viewer/v1/:id/*"
                    element={
                        <React.Suspense fallback={<Loader content='Loading...' />}>
                            <RouterConfig refetch={UserProfileRefetch} />
                        </React.Suspense>
                    }
                />
                <Route
                    path="/viewer/v1/share/:id/*"
                    element={
                        <React.Suspense fallback={<Loader content='Loading...' />}>
                            <ShareRouterConfig />
                        </React.Suspense>
                    }
                />
                <Route
                    path="/viewer/*"
                    element={
                        <React.Suspense fallback={<Loader content='Loading...' />}>
                            <OverviewRouteConfig />
                        </React.Suspense>
                    }
                />
            </Routes>
        </>
    );
};

export default RoutesPage;
